import type { ScentFamily, ScentFamilyDef } from '@/types'

export const scentFamilies: ScentFamilyDef[] = [
  {
    id: 'Citrus',
    label: 'Citrus',
    color: '#D9C56B',
    description: 'Bright, sparkling, sunlit.',
  },
  {
    id: 'Floral',
    label: 'Floral',
    color: '#D48AA0',
    description: 'Romantic, velvety, blooming.',
  },
  {
    id: 'Woody',
    label: 'Woody',
    color: '#9A7B52',
    description: 'Warm, grounding, resinous.',
  },
  {
    id: 'Oriental',
    label: 'Oriental',
    color: '#B05A3C',
    description: 'Spiced, ambery, sensual.',
  },
  {
    id: 'Fresh',
    label: 'Fresh',
    color: '#7FA8A0',
    description: 'Clean, green, airy.',
  },
  {
    id: 'Gourmand',
    label: 'Gourmand',
    color: '#A9794E',
    description: 'Sweet, edible, comforting.',
  },
]

export function getScentFamilyColor(family: ScentFamily): string {
  return scentFamilies.find((f) => f.id === family)?.color ?? '#C8A24B'
}
